import PaymentFailedPage from './PaymentFailedPage';

export default PaymentFailedPage;
